import React, { useState, useMemo, useContext, useEffect } from 'react';
import { SirenButton } from 'app/home/main-pages/devices/Devices'

import { ReactComponent as IconBattery13 } from 'images/device/battery/battery-1-3.svg';
import { ReactComponent as IconBattery23 } from 'images/device/battery/battery-2-3.svg';
import { ReactComponent as IconBatteryCharging } from 'images/device/battery/battery-charging.svg';
import { ReactComponent as IconBatteryEmpty } from 'images/device/battery/battery-empty.svg';
import { ReactComponent as IconBatteryFullConnected } from 'images/device/battery/battery-full-connected.svg';
import { ReactComponent as IconBatteryFullDisconnected } from 'images/device/battery/battery-full-disconnected.svg';

import './All.scss'
import { LocalizationContext } from 'app/localization/Context';

export default function SirenControl({ device, darkerBorder, setBackgroundRed }) {
    const [sirenState, setSirenState] = useState(null);

    const sirenBackPanel = useMemo(() => {
        switch (sirenState) {
            case 'alarming':
                return <div className="siren-status-backpanel alarming" />;
            case 'start-alarming':
                return <div className="siren-status-backpanel start-alarming" />;
            case 'not-alarming':
            default:
                return null;
        }
    }, [sirenState]);

    const borderClass = useMemo(() => {
        switch (sirenState) {
            case 'alarming':
                return '';
            case 'start-alarming':
                return 'siren-start-alarming';
            case 'not-alarming':
            default:
                return '';
        }
    }, [sirenState]);

    const containerClass = useMemo(() => {
        if (device.active) {
            switch (sirenState) {
                case 'alarming':
                    return "device-detail-control active";
                case 'start-alarming':
                    return "device-detail-control siren-start-alarming";
                case 'not-alarming':
                default:
                    return "device-detail-control active";
            }
        } else {
            return "device-detail-control inactive";
        }
    }, [device.active, sirenState]);

    useEffect(() => {
        if (device.active) {
            switch (sirenState) {
                case 'alarming':
                    setBackgroundRed(true);
                    break;
                case 'start-alarming':
                case 'not-alarming':
                default:
                    setBackgroundRed(false);
                    break;
            }
        } else {
            setBackgroundRed(false);
        }
    }, [device.active, sirenState, setBackgroundRed]);

    return (
        <div className={containerClass}>
            <div className={"border " + borderClass + " " + (darkerBorder ? "darker" : "lighter")}>
                {sirenBackPanel}
                <SirenButton on={device.state && device.active} changeState={device.changeState}
                    showStates={true} notifySirenState={setSirenState}
                    waitingForChangeState={device.waitingForChangeState["state"]} />
            </div>
        </div>
    );
}

export function SirenBattery({ device }) {
    const localizeNumber = useContext(LocalizationContext).localizeNumber;

    const percentage = useMemo(() => {
        if (device.battery_level !== undefined) {
            return localizeNumber(String(device.battery_level)) + '%';
        }
        return "";
    }, [device, localizeNumber]);

    const icon = useMemo(() => {
        if (device.power_enabled) {
            if (device.is_charching) {
                return IconBatteryCharging;
            } else {
                return IconBatteryFullConnected;
            }
        } else {
            if (device.battery_level >= 91) { // 90 - 100
                return IconBatteryFullDisconnected;
            } else if (device.battery_level >= 60) { // 60 - 90
                return IconBattery23;
            } else if (device.battery_level >= 30) { // 30 - 60
                return IconBattery13;
            } else { // 0 - 30
                return IconBatteryEmpty;
            }
        }
    }, [device]);

    return (
        <div className="device-detail-battery">
            <div className="percentage">
                {percentage}
            </div>
            {
                React.createElement(icon, { className: "icon" })
            }
        </div>
    );
}